import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import './ComponentError.js';
import './Checkout.js';
import './Pagination.js';
import './Payment.js';
import './SubAccount.js';
import { E as EntityDocumentType } from './Document.js';
import { d as defineCustomElement$3 } from './custom-popper2.js';
import { d as defineCustomElement$2 } from './form-control-file2.js';
import { d as defineCustomElement$1 } from './form-control-tooltip2.js';

const BankAccountDocumentFormInputs = /*@__PURE__*/ proxyCustomElement(class BankAccountDocumentFormInputs extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.inputHandler = undefined;
        this.errors = undefined;
        this.storeFiles = undefined;
    }
    render() {
        return (h("div", { key: '9e04de8ad0e4a1d83f6d8fd1e5a2a5e92c670b92', class: "row gy-3" }, h("div", { key: 'af8875e58677a94873d548c35e9d2859725058e5', class: "col-12" }, h("form-control-file", { key: '030c461b2c2a3da9acf5fcf761f537ea9f6cfcc9', name: "voided_check", label: "Voided Check", documentType: EntityDocumentType.voidedCheck, inputHandler: this.inputHandler, onFileSelected: this.storeFiles, errorText: this.errors["voided_check"], multiple: true })), h("div", { key: '0b6650097a7c6810d9ab9dc76484b49dfe0c7e11', class: "col-12" }, h("form-control-file", { key: 'cd030043373cc6759022b9c23c674830ceffaff3', name: "bank_statement", label: "Bank Statement", documentType: EntityDocumentType.bankStatement, inputHandler: this.inputHandler, onFileSelected: this.storeFiles, errorText: this.errors["bank_statement"], multiple: true }))));
    }
}, [0, "bank-account-document-form-inputs", {
        "inputHandler": [16],
        "errors": [8],
        "storeFiles": [16]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["bank-account-document-form-inputs", "custom-popper", "form-control-file", "form-control-tooltip"];
    components.forEach(tagName => { switch (tagName) {
        case "bank-account-document-form-inputs":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BankAccountDocumentFormInputs);
            }
            break;
        case "custom-popper":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "form-control-file":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "form-control-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { BankAccountDocumentFormInputs as B, defineCustomElement as d };
